import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import LaGachaTaqueria from './LaGachaTaqueria';
import NotFound from '../NotFound';

// The deck lives at /clients/<secret>. Only the SHA-256 of the secret is in this file, so reading the
// public JavaScript does not reveal the link. A wrong or old token gets the normal 404 page.
const DECK_HASH = 'cd385882cedbfdf52a4ca088d83e7c327192894bcf09eda7d1da926522fbcdbe';

async function sha256Hex(text) {
  const bytes = new TextEncoder().encode(text);
  const digest = await crypto.subtle.digest('SHA-256', bytes);
  return [...new Uint8Array(digest)].map((b) => b.toString(16).padStart(2, '0')).join('');
}

export default function LaGachaGate() {
  const { deckToken } = useParams();
  const [allowed, setAllowed] = useState(null);

  useEffect(() => {
    let cancelled = false;
    sha256Hex(deckToken || '')
      .then((hex) => { if (!cancelled) setAllowed(hex === DECK_HASH); })
      .catch(() => { if (!cancelled) setAllowed(false); });
    return () => { cancelled = true; };
  }, [deckToken]);

  if (allowed === null) return null;
  return allowed ? <LaGachaTaqueria deckToken={deckToken} /> : <NotFound />;
}
